import { render, staticRenderFns } from "./InstallersPage.vue?vue&type=template&id=1965879e&scoped=true"
import script from "./InstallersPage.vue?vue&type=script&lang=js"
export * from "./InstallersPage.vue?vue&type=script&lang=js"
import style0 from "./InstallersPage.vue?vue&type=style&index=0&id=1965879e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1965879e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
